import { AllocationHistory, CurrentAllocations } from "../../domains/allocations/components";
import { Button, Grid, Typography } from "@mui/material";
import { PartitionDetails, PartitionWidget } from "../../domains/partitions/components";

import { ProductWidget } from "../../domains/products/components";
import RootPage from "../RootPage";
import RoutePaths from "../../routes/route-paths";
import { generatePath } from "react-router";
import localisations from "../../shell/localisation";
import { reactPlugin } from "../../app-insights";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { withAITracking } from "@microsoft/applicationinsights-react-js";

function ShowPartitionPage() {
    const { id } = useParams<{ id: string }>();
    const {
        heading,
        coreDetailsHeading,
        currentAllocationsHeading,
        allocationHistoryHeading,
        editButton
    } = localisations.pages.showPartition;

    const history = useHistory();

    const navigateToEditPartition = () => {
        history.push(generatePath(RoutePaths.EditPartition, { id: id }));
    };

    const productFormatter = (productId: number) => <ProductWidget productId={productId} />;
    const partitionFormatter = (partitionId: string) => <PartitionWidget partitionId={partitionId} />;

    return (
        <RootPage header={heading}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom>
                        {coreDetailsHeading}&nbsp;
                        <Button
                            onClick={() => navigateToEditPartition()}
                            color="primary"
                            variant="contained"
                        >{editButton}</Button>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                <PartitionDetails partitionId={id} />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom>
                        {currentAllocationsHeading}
                    </Typography>
                    <CurrentAllocations productFormatter={productFormatter} partitionId={id} />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom>
                        {allocationHistoryHeading}
                    </Typography>
                    <AllocationHistory
                        productFormatter={productFormatter}
                        partitionFormatter={partitionFormatter}
                        partitionId={id}
                    />
                </Grid>
            </Grid>
        </RootPage>
    );
}

export default withAITracking(reactPlugin, ShowPartitionPage, "Show Partition Page");
